/** Régions alignées StockDashboard / Capital_flow (affichage FR, filtre cohérent). */

/** Codes pays ISO → libellé région (secours si region absente en base). */
export const COUNTRY_TO_REGION = {
  US: "North America",
  CA: "North America",
  MX: "North America",
  BR: "South America",
  AR: "South America",
  CL: "South America",
  GB: "Europe",
  DE: "Europe",
  FR: "Europe",
  NL: "Europe",
  SE: "Europe",
  CH: "Europe",
  IT: "Europe",
  ES: "Europe",
  BE: "Europe",
  NO: "Europe",
  DK: "Europe",
  FI: "Europe",
  LU: "Europe",
  IE: "Europe",
  AT: "Europe",
  PL: "Europe",
  GR: "Europe",
  JP: "North Asia",
  CN: "North Asia",
  KR: "North Asia",
  TW: "North Asia",
  IN: "South Asia",
  PK: "South Asia",
  BD: "South Asia",
  ID: "Southeast Asia",
  MY: "Southeast Asia",
  TH: "Southeast Asia",
  PH: "Southeast Asia",
  VN: "Southeast Asia",
  SG: "Southeast Asia",
  AU: "Oceania",
  NZ: "Oceania",
  HK: "North Asia",
  ZA: "Africa",
  NG: "Africa",
  KE: "Africa",
  EG: "Africa",
  IL: "Middle East",
  AE: "Middle East",
  SA: "Middle East",
  QA: "Middle East",
  KW: "Middle East",
  KZ: "North Asia",
  RU: "Europe",
  TR: "Europe",
};

/** Libellés FR pour l’UI (évite encodage cassé type AmÃ©rique). */
export const REGION_EN_TO_FR = {
  "North America": "Amérique du Nord",
  "South America": "Amérique du Sud",
  "Latin America": "Amérique latine",
  "Europe": "Europe",
  "North Asia": "Asie du Nord",
  "South Asia": "Asie du Sud",
  "Southeast Asia": "Asie du Sud-Est",
  "Asia": "Asie",
  "Central Asia": "Asie centrale",
  "Middle East": "Moyen-Orient",
  "Africa": "Afrique",
  "Oceania": "Océanie",
  "Eastern Europe": "Europe de l'Est",
  "Southeast Europe": "Europe du Sud-Est",
  "MENA": "Moyen-Orient",
  "LatAm": "Amérique latine",
};

export function isCountryCode(value) {
  const s = String(value || "").trim();
  return /^[A-Z]{2}$/i.test(s);
}

/** Région canonique (anglais DB / flux marché). */
export function canonicalRegionEn(region, countryOrMarket) {
  const r = String(region || "").trim();
  if (r && !isCountryCode(r)) return r;
  const cc = String(countryOrMarket || "")
    .trim()
    .toUpperCase();
  if (cc && COUNTRY_TO_REGION[cc]) return COUNTRY_TO_REGION[cc];
  return r && !isCountryCode(r) ? r : "";
}

/** Libellé affiché en français. */
export function regionLabelFr(regionEn) {
  const key = String(regionEn || "").trim();
  if (!key) return "—";
  if (REGION_EN_TO_FR[key]) return REGION_EN_TO_FR[key];
  if (isCountryCode(key)) {
    const via = COUNTRY_TO_REGION[key.toUpperCase()];
    if (via) return REGION_EN_TO_FR[via] || via;
  }
  return key;
}

/** Région pour filtre screener / affichage carte. */
export function resolveStockRegion(row) {
  const country = row?.country ?? row?.market ?? "";
  const en = canonicalRegionEn(row?.region, country);
  return {
    regionEn: en,
    regionFr: regionLabelFr(en),
  };
}

export function normalizeScreenerStock(row) {
  const { regionEn, regionFr } = resolveStockRegion(row);
  return {
    ...row,
    region: regionEn || row?.region || "",
    regionFr: regionFr || regionLabelFr(regionEn),
  };
}

/** Options filtre région : uniquement vraies régions (pas codes pays). */
export function buildRegionFilterOptions(stocks) {
  const set = new Set();
  (stocks || []).forEach((s) => {
    const { regionFr } = resolveStockRegion(s);
    if (regionFr && regionFr !== "—") set.add(regionFr);
  });
  return ["Tous", ...Array.from(set).sort((a, b) => a.localeCompare(b, "fr"))];
}

export const REGION_COLORS = {
  "Amérique du Nord": "#6f8a5b",
  "Amérique du Sud": "#8a7a5b",
  "Amérique latine": "#8a7a5b",
  "Europe": "#5b7a8a",
  "Asie du Nord": "#caa85e",
  "Asie du Sud": "#8da57a",
  "Asie du Sud-Est": "#a9b38a",
  "Asie": "#caa85e",
  "Asie centrale": "#6b8a8a",
  "Moyen-Orient": "#d28a52",
  "Afrique": "#c6523f",
  "Océanie": "#7a8a9a",
  "Europe de l'Est": "#7a6b8a",
  "Europe du Sud-Est": "#6b7a8a",
};
